module.exports = __webpack_public_path__ + "static/media/about-19.ab3ca3eb.webp";